export const LIMIT_LENGTH = 10000
export const MAX_SIDEBAR_WIDTH = 300
export const IS_INMAINTENANCE = false
export const WATERMARK_TEXT = '由紫东太初生成，内容仅供参考'
export const SAFTY_TEXT =
  '非常抱歉，这个问题我暂时无法回答，如果您有其他的问题咨询，我非常乐意帮助你'

export enum StoreKey {
  User = 'chat-taichu-userinfo',
  Common = 'chat-taichu-common',
  Timbre = 'chat-taichu-timbre',
}

export enum ScreenSize {
  xs = 0,
  sm = 768,
  md = 1024,
  lg = 1200,
  xl = 1400,
}

export enum ThumbTypes {
  good = 1,
  bad = -1,
  empty = 0,
}

export enum RoleTypes {
  assistant = 1,
  user = 0,
}

export enum GenderTypes {
  man = 1,
  woman = 2,
}

export enum SessionStatuTypes {
  loading = 'loading',
  pending = 'pending',
  ready = 'ready',
  error = 'error',
  risk = 'risk',
}

export enum PluginsTypes {
  docs_qa = 'docs_qa',
}

export enum StatisticActionTypes {
  WEB_ACTION_CLICK = 'WEB_ACTION_CLICK', // 各模块点击率
  WEB_RUNNING_DUR = 'WEB_RUNNING_DUR', // 页面停留时间
  WEB_RUNNING_TIME = 'WEB_RUNNING_TIME',
}

export enum StatisticActionClickTags {
  view = 'view', // 进入
  create = 'create', // 创建
  write = 'write', // 填写
  publish = 'publish', // 发布
}

export enum StatisticCategoryTypes {
  creativity = 'creativity', // 创意
  assistant = 'assistant', // 助手
  chat = 'chat', // 对话
}

export const DocFileAccept = ['.docx', '.pdf', '.txt', '.md']
export const VideoFileAccept = ['.mp4', '.mov', '.avi']
